import moment from "moment";
import React from "react";
import {
    loadFont,
    marketingCreativeColorSchemes,
    marketingCreativeTemplateKeys,
} from "ui/pages/marketing/MarketingCreatives/data";
import { handleDateFormat } from "utils/Utils";

export const RivblisStorySimple = (props) => {
    const { textData, coverImage } = props;

    const defaultColorScheme =
        marketingCreativeColorSchemes?.[marketingCreativeTemplateKeys.Rivblis]
            ?.schemes?.[0];

    const color1 = props?.colors?.[0] || defaultColorScheme?.[0];
    const color2 = props?.colors?.[1] || defaultColorScheme?.[1];
    const color3 = props?.colors?.[2] || defaultColorScheme?.[2];

    const startDateExists = textData?.start_date_time?.exists;
    const startDate = startDateExists && textData?.start_date_time?.date;
    const startTime = startDateExists && textData?.start_date_time?.time;
    const endDateExists = textData?.end_date_time?.exists;
    const endDate = endDateExists && textData?.end_date_time?.date;
    const endTime = endDateExists && textData?.end_date_time?.time;

    React.useEffect(() => {
        loadFont(
            "https://fonts.googleapis.com/css2?family=Josefin+Sans&display=swap"
        );
    }, []);

    return (
        <div style={{ fontFamily: "Josefin Sans", textAlign: "right" }}>
            <div
                style={{
                    position: "absolute",
                    top: "288px",
                    right: "62px",
                    wordBreak: "break-word",
                }}
            >
                {textData?.heading ? (
                    <div
                        style={{
                            color: color2,
                            fontWeight: 700,
                            fontSize: "96px",
                            width: "876px",
                        }}
                    >
                        {textData?.heading}
                    </div>
                ) : null}
                {textData?.sub_heading ? (
                    <div
                        style={{
                            color: color2,
                            fontWeight: 500,
                            fontSize: "48px",
                            width: "829px",
                            marginBottom: "41px",
                        }}
                    >
                        {textData?.sub_heading}
                    </div>
                ) : null}
            </div>
            {startDate ? (
                <div
                    style={{
                        position: "absolute",
                        color: color3,
                        backgroundColor: `${color2}B2`,
                        top: "1455px",
                        right: "0px",
                        fontWeight: 500,
                        fontSize: "33px",
                        width: "626px",
                        padding: "28px",
                        zIndex: 1,
                        whiteSpace: "nowrap",
                    }}
                >
                    {textData?.action_text ? (
                        <div style={{ height: "77px", width: "100%" }} />
                    ) : null}
                    <div className="d-flex align-items-center justify-content-end">
                        <div style={{ position: "relative", top: "7px" }}>
                            {endDate
                                ? handleDateFormat(startDate, false, false) +
                                  " - " +
                                  handleDateFormat(endDate, false, false)
                                : null}
                            {!endDate
                                ? handleDateFormat(startDate, false)
                                : null}
                        </div>
                        <svg
                            style={{
                                marginLeft: "20px",
                            }}
                            width="32"
                            height="32"
                            viewBox="0 0 33 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8.4 3.7002H8C4.22876 3.7002 2.34315 3.7002 1.17157 4.87177C0 6.04334 0 7.92896 0 11.7002V14.0002C0 14.2359 0 14.3537 0.0732233 14.427C0.146447 14.5002 0.264298 14.5002 0.5 14.5002H31.9C32.1357 14.5002 32.2536 14.5002 32.3268 14.427C32.4 14.3537 32.4 14.2359 32.4 14.0002V11.7002C32.4 7.92896 32.4 6.04334 31.2284 4.87177C30.0569 3.7002 28.1712 3.7002 24.4 3.7002H24L24 8.20019C24 9.02862 23.3284 9.70019 22.5 9.7002C21.6716 9.7002 21 9.02862 21 8.2002L21 3.7002H11.4L11.4 8.20019C11.4 9.02862 10.7284 9.70019 9.90001 9.7002C9.07158 9.7002 8.40001 9.02862 8.40001 8.2002L8.4 3.7002Z"
                                fill={color1}
                            />
                            <path
                                d="M0 16.7998C0 16.5641 0 16.4463 0.0732233 16.373C0.146447 16.2998 0.264298 16.2998 0.5 16.2998H31.9C32.1357 16.2998 32.2536 16.2998 32.3268 16.373C32.4 16.4463 32.4 16.5641 32.4 16.7998V24.4998C32.4 28.271 32.4 30.1567 31.2284 31.3282C30.0569 32.4998 28.1712 32.4998 24.4 32.4998H8C4.22876 32.4998 2.34315 32.4998 1.17157 31.3282C0 30.1567 0 28.271 0 24.4998V16.7998Z"
                                fill={color1}
                                fill-opacity="0.35"
                            />
                            <path
                                d="M9.90038 1L9.90039 8.2"
                                stroke={color1}
                                stroke-linecap="round"
                            />
                            <path
                                d="M22.5 1L22.5 8.2"
                                stroke={color1}
                                stroke-linecap="round"
                            />
                        </svg>
                    </div>

                    {startTime ? (
                        <div className="d-flex align-items-center justify-content-end mt-4">
                            <div style={{ position: "relative", top: "7px" }}>
                                {startTime || null}
                                {endTime ? " - " + endTime : null}
                            </div>
                            <svg
                                style={{
                                    marginLeft: "20px",
                                }}
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="16"
                                    cy="16"
                                    r="16"
                                    fill={color1}
                                    fill-opacity="0.35"
                                />
                                <path
                                    d="M16 6V15.75C16 15.8881 16.1119 16 16.25 16H22"
                                    stroke={color1}
                                    stroke-width="3"
                                    stroke-linecap="round"
                                />
                            </svg>
                        </div>
                    ) : null}
                </div>
            ) : null}
            {textData?.action_text ? (
                <div
                    style={{
                        position: "absolute",
                        color: color1,
                        backgroundColor: color3,
                        top: "1455px",
                        right: "0px",
                        padding: "20px 28px",
                        fontWeight: 600,
                        fontSize: "36px",
                        zIndex: 2,
                    }}
                >
                    {textData?.action_text}
                </div>
            ) : null}
            {textData?.additional_text ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "34px",
                        left: "46px",
                        fontWeight: 500,
                        fontSize: "32px",
                        whiteSpace: "nowrap",
                    }}
                >
                    {textData?.additional_text}
                </div>
            ) : null}
            {coverImage ? (
                <div
                    style={{
                        position: "absolute",
                        width: "625px",
                        height: "1092px",
                        bottom: "0px",
                        left: "0px",
                        backgroundImage: "url(" + coverImage + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                />
            ) : null}

            <svg
                style={{
                    position: "absolute",
                    top: "860px",
                    right: "183px",
                    zIndex: 1,
                }}
                width="504"
                height="100"
                viewBox="0 0 504 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.516 31.9429C10.7752 32.3135 14.8161 30.8513 15.5466 28.6764L15.5474 28.6741L15.5547 28.6535C15.5648 28.6256 15.5829 28.5763 15.6097 28.507C15.6635 28.3682 15.7521 28.1499 15.8808 27.8635C16.1386 27.2897 16.5548 26.4482 17.1702 25.4292C18.4099 23.3767 20.4124 20.6802 23.4592 18.02C29.5479 12.7038 39.1408 7.99993 54.8048 7.99993C71.1092 7.99993 83.7149 12.9568 98.8544 19.1268L99.6614 19.4559C107.578 22.6841 116.279 26.2322 126.312 28.7286C134.188 30.6882 142.885 31.9997 152.668 31.9997C162.408 31.9997 171.072 30.6997 178.92 28.7544C188.997 26.2567 197.731 22.6953 205.675 19.4559L206.482 19.1268C221.622 12.9568 234.227 7.99993 250.532 7.99993C266.836 7.99993 279.442 12.9568 294.581 19.1268L295.388 19.4559C303.407 22.7259 312.231 26.3241 322.43 28.825C330.202 30.7311 338.774 31.9997 348.395 31.9997C357.974 31.9997 366.512 30.7424 374.257 28.8505C384.499 26.3486 393.356 22.737 401.402 19.4559L402.209 19.1268C417.349 12.9568 429.954 7.99993 446.259 7.99993C462.044 7.99993 472.414 12.7751 479.258 18.1742C482.664 20.8612 485.013 23.5789 486.511 25.6414C487.256 26.6661 487.778 27.5125 488.108 28.0899C488.273 28.3782 488.389 28.5982 488.46 28.7384C488.496 28.8085 488.521 28.8585 488.534 28.8871L488.544 28.9067L488.546 28.9109L488.547 28.9127L488.547 28.9141C489.534 31.0613 493.738 32.3958 497.944 31.8955C502.155 31.3947 504.775 29.2444 503.794 27.0928L496.169 27.9997C503.794 27.0928 503.794 27.0912 503.793 27.0896L503.791 27.0857L503.787 27.0764L503.775 27.0511L503.739 26.9747C503.709 26.9125 503.667 26.8278 503.613 26.7221C503.505 26.5107 503.349 26.2151 503.138 25.8471C502.718 25.1121 502.081 24.0834 501.191 22.8582C499.421 20.4207 496.601 17.1385 492.401 13.8255C484.034 7.22475 469.449 0 446.259 0C424.013 0 407.383 6.7815 393.252 12.5439L392.445 12.8729C377.305 19.0429 364.7 23.9998 348.395 23.9998C332.091 23.9998 319.485 19.0429 304.346 12.8729L303.539 12.5439C289.408 6.7815 272.777 0 250.532 0C228.286 0 211.656 6.78149 197.525 12.5439L196.718 12.8729C181.578 19.0429 168.973 23.9998 152.668 23.9998C136.364 23.9998 123.758 19.0429 108.619 12.8729L107.812 12.5439C93.6807 6.78149 77.0505 0 54.8048 0C31.4939 0 17.5995 7.29605 9.94472 13.9797C6.11976 17.3194 3.68643 20.6229 2.20824 23.0704C1.46473 24.3014 0.951489 25.3349 0.619585 26.0736C0.45342 26.4434 0.332085 26.7407 0.249635 26.9535C0.208393 27.0599 0.17683 27.1454 0.154209 27.2083L0.126874 27.2857L0.118052 27.3114L0.114823 27.3209L0.113499 27.3249C0.112917 27.3266 0.112368 27.3282 7.83033 27.9997L0.112368 27.3282C-0.613519 29.506 2.25348 31.5721 6.516 31.9429Z"
                    fill={color2}
                    fill-opacity="0.8"
                />
                <path
                    d="M15.5466 62.6761C14.8161 64.851 10.7752 66.3132 6.516 65.9426C2.25348 65.5718 -0.613519 63.5057 0.112368 61.3279L7.83033 61.9994C0.112368 61.3279 0.112917 61.3263 0.113499 61.3246L0.114823 61.3206L0.118052 61.3111L0.126874 61.2853L0.154209 61.208C0.17683 61.1451 0.208393 61.0596 0.249635 60.9532C0.332085 60.7404 0.45342 60.4431 0.619585 60.0733C0.951489 59.3346 1.46473 58.3011 2.20824 57.07C3.68643 54.6226 6.11976 51.3191 9.94472 47.9794C17.5995 41.2957 31.4939 33.9997 54.8048 33.9997C77.0505 33.9997 93.6807 40.7812 107.812 46.5435L108.619 46.8726C123.758 53.0426 136.364 57.9995 152.668 57.9995C168.973 57.9995 181.578 53.0426 196.718 46.8726L197.525 46.5435C211.656 40.7812 228.286 33.9997 250.532 33.9997C272.777 33.9997 289.408 40.7812 303.539 46.5436L304.346 46.8726C319.485 53.0426 332.091 57.9995 348.395 57.9995C364.7 57.9995 377.305 53.0426 392.445 46.8726L393.252 46.5436C407.383 40.7812 424.013 33.9997 446.259 33.9997C469.449 33.9997 484.034 41.2244 492.401 47.8252C496.601 51.1382 499.421 54.4204 501.191 56.8579C502.081 58.0831 502.718 59.1118 503.138 59.8468C503.349 60.2148 503.505 60.5104 503.613 60.7218C503.667 60.8275 503.709 60.9122 503.739 60.9744L503.775 61.0508L503.787 61.0761L503.791 61.0854L503.793 61.0893C503.794 61.0909 503.794 61.0925 496.169 61.9994L503.794 61.0925C504.775 63.2441 502.155 65.3944 497.944 65.8952C493.738 66.3955 489.534 65.061 488.547 62.9138L488.547 62.9124L488.546 62.9106L488.544 62.9064L488.534 62.8868C488.521 62.8582 488.496 62.8082 488.46 62.7381C488.389 62.5979 488.273 62.3779 488.108 62.0896C487.778 61.5122 487.256 60.6658 486.511 59.6411C485.013 57.5786 482.664 54.8609 479.258 52.1739C472.414 46.7748 462.044 41.9996 446.259 41.9996C429.954 41.9996 417.349 46.9565 402.209 53.1265L401.402 53.4555C393.356 56.7367 384.499 60.3483 374.257 62.8502C366.512 64.7421 357.974 65.9994 348.395 65.9994C338.774 65.9994 330.202 64.7308 322.43 62.8247C312.231 60.3238 303.407 56.7256 295.388 53.4556L294.581 53.1265C279.442 46.9565 266.836 41.9996 250.532 41.9996C234.227 41.9996 221.622 46.9565 206.482 53.1265L205.675 53.4556C197.731 56.695 188.997 60.2564 178.92 62.7541C171.072 64.6994 162.408 65.9994 152.668 65.9994C142.885 65.9994 134.188 64.6879 126.312 62.7283C116.279 60.2319 107.578 56.6838 99.6614 53.4556L98.8544 53.1265C83.7149 46.9565 71.1092 41.9996 54.8048 41.9996C39.1408 41.9996 29.5479 46.7035 23.4592 52.0197C20.4124 54.6799 18.4099 57.3764 17.1702 59.4289C16.5548 60.4479 16.1386 61.2894 15.8808 61.8632C15.7521 62.1496 15.6635 62.3679 15.6097 62.5066C15.5829 62.576 15.5648 62.6253 15.5547 62.6532L15.5474 62.6738L15.5466 62.6761Z"
                    fill={color2}
                    fill-opacity="0.8"
                />
                <path
                    d="M15.5474 96.6735L15.547 96.6745C14.8176 98.8501 10.776 100.313 6.516 99.9423C2.25348 99.5715 -0.613519 97.5054 0.112368 95.3276L7.83033 95.9991C0.112368 95.3276 0.112917 95.326 0.113499 95.3243L0.114823 95.3203L0.118052 95.3108L0.126874 95.285L0.154209 95.2077C0.17683 95.1448 0.208393 95.0593 0.249635 94.9529C0.332085 94.7401 0.45342 94.4428 0.619585 94.073C0.951489 93.3343 1.46473 92.3008 2.20824 91.0697C3.68643 88.6223 6.11976 85.3188 9.94472 81.9791C17.5995 75.2954 31.4939 67.9994 54.8048 67.9994C77.0505 67.9994 93.6807 74.7809 107.812 80.5432L108.619 80.8723C123.758 87.0423 136.364 91.9992 152.668 91.9992C168.973 91.9992 181.578 87.0423 196.718 80.8723L197.525 80.5432C211.656 74.7809 228.286 67.9994 250.532 67.9994C272.777 67.9994 289.408 74.7809 303.539 80.5433L304.346 80.8723C319.485 87.0423 332.091 91.9992 348.395 91.9992C364.7 91.9992 377.305 87.0423 392.445 80.8723L393.252 80.5433C407.383 74.7809 424.013 67.9994 446.259 67.9994C469.449 67.9994 484.034 75.2241 492.401 81.8249C496.601 85.1379 499.421 88.4201 501.191 90.8576C502.081 92.0828 502.718 93.1115 503.138 93.8465C503.349 94.2145 503.505 94.5101 503.613 94.7214C503.667 94.8271 503.709 94.9119 503.739 94.9741L503.775 95.0505L503.787 95.0758L503.791 95.0851L503.793 95.0889C503.794 95.0906 503.794 95.0922 496.169 95.9991L503.794 95.0922C504.775 97.2438 502.155 99.3941 497.944 99.8949C493.738 100.395 489.534 99.0607 488.547 96.9135L488.547 96.9121L488.546 96.9103L488.544 96.9061L488.534 96.8864C488.528 96.8735 488.52 96.8562 488.509 96.8347C488.496 96.8086 488.48 96.7762 488.46 96.7378C488.389 96.5975 488.273 96.3776 488.108 96.0893C487.778 95.5119 487.256 94.6655 486.511 93.6408C485.013 91.5783 482.664 88.8606 479.258 86.1736C472.414 80.7745 462.044 75.9993 446.259 75.9993C429.954 75.9993 417.349 80.9562 402.209 87.1262L401.402 87.4552C393.356 90.7364 384.499 94.348 374.257 96.8499C366.512 98.7418 357.974 99.9991 348.395 99.9991C338.774 99.9991 330.202 98.7305 322.43 96.8244C312.231 94.3235 303.407 90.7253 295.388 87.4552L294.581 87.1262C279.442 80.9562 266.836 75.9993 250.532 75.9993C234.227 75.9993 221.622 80.9562 206.482 87.1262L205.675 87.4553C197.731 90.6947 188.997 94.2561 178.92 96.7538C171.072 98.6991 162.408 99.9991 152.668 99.9991C142.885 99.9991 134.188 98.6876 126.312 96.7279C116.279 94.2316 107.578 90.6835 99.6616 87.4553L98.8544 87.1262C83.7149 80.9562 71.1092 75.9993 54.8048 75.9993C39.1408 75.9993 29.5479 80.7032 23.4592 86.0194C20.4124 88.6796 18.4099 91.3761 17.1702 93.4286C16.5548 94.4476 16.1386 95.2891 15.8808 95.8629C15.7521 96.1493 15.6635 96.3676 15.6097 96.5063C15.5829 96.5757 15.5648 96.625 15.5547 96.6529L15.5474 96.6735Z"
                    fill={color2}
                    fill-opacity="0.8"
                />
            </svg>
            <svg
                style={{
                    position: "absolute",
                    top: "1804px",
                    right: "394px",
                    zIndex: 1,
                }}
                width="121"
                height="38"
                viewBox="0 0 121 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M0 38L33 19L1.79446e-06 0L0 38Z" fill={color3} />
                <path d="M77 19L44 38V0L77 19Z" fill={color3} />
                <path d="M121 19L88 38V0L121 19Z" fill={color3} />
            </svg>
            <svg
                width="60"
                height="260"
                style={{
                    position: "absolute",
                    top: "487px",
                    left: "22px",
                    zIndex: 1,
                }}
                viewBox="0 0 60 260"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10ZM5 60C7.76142 60 10 57.7614 10 55C10 52.2386 7.76142 50 5 50C2.23858 50 0 52.2386 0 55C0 57.7614 2.23858 60 5 60ZM10 105C10 107.761 7.76142 110 5 110C2.23858 110 0 107.761 0 105C0 102.239 2.23858 100 5 100C7.76142 100 10 102.239 10 105ZM5 160C7.76142 160 10 157.761 10 155C10 152.239 7.76142 150 5 150C2.23858 150 0 152.239 0 155C0 157.761 2.23858 160 5 160ZM10 205C10 207.761 7.76142 210 5 210C2.23858 210 0 207.761 0 205C0 202.239 2.23858 200 5 200C7.76142 200 10 202.239 10 205ZM5 260C7.76142 260 10 257.761 10 255C10 252.239 7.76142 250 5 250C2.23858 250 0 252.239 0 255C0 257.761 2.23858 260 5 260ZM60 5C60 7.76142 57.7614 10 55 10C52.2386 10 50 7.76142 50 5C50 2.23858 52.2386 0 55 0C57.7614 0 60 2.23858 60 5ZM55 60C57.7614 60 60 57.7614 60 55C60 52.2386 57.7614 50 55 50C52.2386 50 50 52.2386 50 55C50 57.7614 52.2386 60 55 60ZM60 105C60 107.761 57.7614 110 55 110C52.2386 110 50 107.761 50 105C50 102.239 52.2386 100 55 100C57.7614 100 60 102.239 60 105ZM55 160C57.7614 160 60 157.761 60 155C60 152.239 57.7614 150 55 150C52.2386 150 50 152.239 50 155C50 157.761 52.2386 160 55 160ZM60 205C60 207.761 57.7614 210 55 210C52.2386 210 50 207.761 50 205C50 202.239 52.2386 200 55 200C57.7614 200 60 202.239 60 205ZM55 260C57.7614 260 60 257.761 60 255C60 252.239 57.7614 250 55 250C52.2386 250 50 252.239 50 255C50 257.761 52.2386 260 55 260Z"
                    fill={color2}
                />
            </svg>
            <svg
                width="1080"
                height="1920"
                viewBox="0 0 1080 1920"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="1080" height="1920" fill={color1} />
                <path d="M897 224L930 205L897 186L897 224Z" fill={color2} />
                <path d="M974 205L941 224V186L974 205Z" fill={color2} />
                <path d="M1018 205L985 224V186L1018 205Z" fill={color2} />
                <path
                    d="M882.645 1167.82C882.645 1169.38 881.381 1170.65 879.823 1170.65C878.264 1170.65 877 1169.38 877 1167.82C877 1166.26 878.264 1165 879.823 1165C881.381 1165 882.645 1166.26 882.645 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1167.82C899.581 1169.38 898.317 1170.65 896.758 1170.65C895.199 1170.65 893.935 1169.38 893.935 1167.82C893.935 1166.26 895.199 1165 896.758 1165C898.317 1165 899.581 1166.26 899.581 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1167.82C916.516 1169.38 915.252 1170.65 913.694 1170.65C912.135 1170.65 910.871 1169.38 910.871 1167.82C910.871 1166.26 912.135 1165 913.694 1165C915.252 1165 916.516 1166.26 916.516 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1167.82C933.452 1169.38 932.188 1170.65 930.629 1170.65C929.07 1170.65 927.806 1169.38 927.806 1167.82C927.806 1166.26 929.07 1165 930.629 1165C932.188 1165 933.452 1166.26 933.452 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1167.82C950.387 1169.38 949.123 1170.65 947.565 1170.65C946.006 1170.65 944.742 1169.38 944.742 1167.82C944.742 1166.26 946.006 1165 947.565 1165C949.123 1165 950.387 1166.26 950.387 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1167.82C967.323 1169.38 966.059 1170.65 964.5 1170.65C962.941 1170.65 961.677 1169.38 961.677 1167.82C961.677 1166.26 962.941 1165 964.5 1165C966.059 1165 967.323 1166.26 967.323 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1167.82C984.258 1169.38 982.994 1170.65 981.435 1170.65C979.877 1170.65 978.613 1169.38 978.613 1167.82C978.613 1166.26 979.877 1165 981.435 1165C982.994 1165 984.258 1166.26 984.258 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1167.82C1001.19 1169.38 999.93 1170.65 998.371 1170.65C996.812 1170.65 995.548 1169.38 995.548 1167.82C995.548 1166.26 996.812 1165 998.371 1165C999.93 1165 1001.19 1166.26 1001.19 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1167.82C1018.13 1169.38 1016.87 1170.65 1015.31 1170.65C1013.75 1170.65 1012.48 1169.38 1012.48 1167.82C1012.48 1166.26 1013.75 1165 1015.31 1165C1016.87 1165 1018.13 1166.26 1018.13 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1167.82C1035.06 1169.38 1033.8 1170.65 1032.24 1170.65C1030.68 1170.65 1029.42 1169.38 1029.42 1167.82C1029.42 1166.26 1030.68 1165 1032.24 1165C1033.8 1165 1035.06 1166.26 1035.06 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M1052 1167.82C1052 1169.38 1050.74 1170.65 1049.18 1170.65C1047.62 1170.65 1046.35 1169.38 1046.35 1167.82C1046.35 1166.26 1047.62 1165 1049.18 1165C1050.74 1165 1052 1166.26 1052 1167.82Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1184.76C882.645 1186.32 881.381 1187.59 879.823 1187.59C878.264 1187.59 877 1186.32 877 1184.76C877 1183.21 878.264 1181.94 879.823 1181.94C881.381 1181.94 882.645 1183.21 882.645 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1184.76C899.581 1186.32 898.317 1187.59 896.758 1187.59C895.199 1187.59 893.935 1186.32 893.935 1184.76C893.935 1183.21 895.199 1181.94 896.758 1181.94C898.317 1181.94 899.581 1183.21 899.581 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1184.76C916.516 1186.32 915.252 1187.59 913.694 1187.59C912.135 1187.59 910.871 1186.32 910.871 1184.76C910.871 1183.21 912.135 1181.94 913.694 1181.94C915.252 1181.94 916.516 1183.21 916.516 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1184.76C933.452 1186.32 932.188 1187.59 930.629 1187.59C929.07 1187.59 927.806 1186.32 927.806 1184.76C927.806 1183.21 929.07 1181.94 930.629 1181.94C932.188 1181.94 933.452 1183.21 933.452 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1184.76C950.387 1186.32 949.123 1187.59 947.565 1187.59C946.006 1187.59 944.742 1186.32 944.742 1184.76C944.742 1183.21 946.006 1181.94 947.565 1181.94C949.123 1181.94 950.387 1183.21 950.387 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1184.76C967.323 1186.32 966.059 1187.59 964.5 1187.59C962.941 1187.59 961.677 1186.32 961.677 1184.76C961.677 1183.21 962.941 1181.94 964.5 1181.94C966.059 1181.94 967.323 1183.21 967.323 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1184.76C984.258 1186.32 982.994 1187.59 981.435 1187.59C979.877 1187.59 978.613 1186.32 978.613 1184.76C978.613 1183.21 979.877 1181.94 981.435 1181.94C982.994 1181.94 984.258 1183.21 984.258 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1184.76C1001.19 1186.32 999.93 1187.59 998.371 1187.59C996.812 1187.59 995.548 1186.32 995.548 1184.76C995.548 1183.21 996.812 1181.94 998.371 1181.94C999.93 1181.94 1001.19 1183.21 1001.19 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1184.76C1018.13 1186.32 1016.87 1187.59 1015.31 1187.59C1013.75 1187.59 1012.48 1186.32 1012.48 1184.76C1012.48 1183.21 1013.75 1181.94 1015.31 1181.94C1016.87 1181.94 1018.13 1183.21 1018.13 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1184.76C1035.06 1186.32 1033.8 1187.59 1032.24 1187.59C1030.68 1187.59 1029.42 1186.32 1029.42 1184.76C1029.42 1183.21 1030.68 1181.94 1032.24 1181.94C1033.8 1181.94 1035.06 1183.21 1035.06 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M1052 1184.76C1052 1186.32 1050.74 1187.59 1049.18 1187.59C1047.62 1187.59 1046.35 1186.32 1046.35 1184.76C1046.35 1183.21 1047.62 1181.94 1049.18 1181.94C1050.74 1181.94 1052 1183.21 1052 1184.76Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1201.71C882.645 1203.27 881.381 1204.53 879.823 1204.53C878.264 1204.53 877 1203.27 877 1201.71C877 1200.15 878.264 1198.88 879.823 1198.88C881.381 1198.88 882.645 1200.15 882.645 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1201.71C899.581 1203.27 898.317 1204.53 896.758 1204.53C895.199 1204.53 893.935 1203.27 893.935 1201.71C893.935 1200.15 895.199 1198.88 896.758 1198.88C898.317 1198.88 899.581 1200.15 899.581 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1201.71C916.516 1203.27 915.252 1204.53 913.694 1204.53C912.135 1204.53 910.871 1203.27 910.871 1201.71C910.871 1200.15 912.135 1198.88 913.694 1198.88C915.252 1198.88 916.516 1200.15 916.516 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1201.71C933.452 1203.27 932.188 1204.53 930.629 1204.53C929.07 1204.53 927.806 1203.27 927.806 1201.71C927.806 1200.15 929.07 1198.88 930.629 1198.88C932.188 1198.88 933.452 1200.15 933.452 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1201.71C950.387 1203.27 949.123 1204.53 947.565 1204.53C946.006 1204.53 944.742 1203.27 944.742 1201.71C944.742 1200.15 946.006 1198.88 947.565 1198.88C949.123 1198.88 950.387 1200.15 950.387 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1201.71C967.323 1203.27 966.059 1204.53 964.5 1204.53C962.941 1204.53 961.677 1203.27 961.677 1201.71C961.677 1200.15 962.941 1198.88 964.5 1198.88C966.059 1198.88 967.323 1200.15 967.323 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1201.71C984.258 1203.27 982.994 1204.53 981.435 1204.53C979.877 1204.53 978.613 1203.27 978.613 1201.71C978.613 1200.15 979.877 1198.88 981.435 1198.88C982.994 1198.88 984.258 1200.15 984.258 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1201.71C1001.19 1203.27 999.93 1204.53 998.371 1204.53C996.812 1204.53 995.548 1203.27 995.548 1201.71C995.548 1200.15 996.812 1198.88 998.371 1198.88C999.93 1198.88 1001.19 1200.15 1001.19 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1201.71C1018.13 1203.27 1016.87 1204.53 1015.31 1204.53C1013.75 1204.53 1012.48 1203.27 1012.48 1201.71C1012.48 1200.15 1013.75 1198.88 1015.31 1198.88C1016.87 1198.88 1018.13 1200.15 1018.13 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1201.71C1035.06 1203.27 1033.8 1204.53 1032.24 1204.53C1030.68 1204.53 1029.42 1203.27 1029.42 1201.71C1029.42 1200.15 1030.68 1198.88 1032.24 1198.88C1033.8 1198.88 1035.06 1200.15 1035.06 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M1052 1201.71C1052 1203.27 1050.74 1204.53 1049.18 1204.53C1047.62 1204.53 1046.35 1203.27 1046.35 1201.71C1046.35 1200.15 1047.62 1198.88 1049.18 1198.88C1050.74 1198.88 1052 1200.15 1052 1201.71Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1218.65C882.645 1220.21 881.381 1221.47 879.823 1221.47C878.264 1221.47 877 1220.21 877 1218.65C877 1217.09 878.264 1215.82 879.823 1215.82C881.381 1215.82 882.645 1217.09 882.645 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1218.65C899.581 1220.21 898.317 1221.47 896.758 1221.47C895.199 1221.47 893.935 1220.21 893.935 1218.65C893.935 1217.09 895.199 1215.82 896.758 1215.82C898.317 1215.82 899.581 1217.09 899.581 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1218.65C916.516 1220.21 915.252 1221.47 913.694 1221.47C912.135 1221.47 910.871 1220.21 910.871 1218.65C910.871 1217.09 912.135 1215.82 913.694 1215.82C915.252 1215.82 916.516 1217.09 916.516 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1218.65C933.452 1220.21 932.188 1221.47 930.629 1221.47C929.07 1221.47 927.806 1220.21 927.806 1218.65C927.806 1217.09 929.07 1215.82 930.629 1215.82C932.188 1215.82 933.452 1217.09 933.452 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1218.65C950.387 1220.21 949.123 1221.47 947.565 1221.47C946.006 1221.47 944.742 1220.21 944.742 1218.65C944.742 1217.09 946.006 1215.82 947.565 1215.82C949.123 1215.82 950.387 1217.09 950.387 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1218.65C967.323 1220.21 966.059 1221.47 964.5 1221.47C962.941 1221.47 961.677 1220.21 961.677 1218.65C961.677 1217.09 962.941 1215.82 964.5 1215.82C966.059 1215.82 967.323 1217.09 967.323 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1218.65C984.258 1220.21 982.994 1221.47 981.435 1221.47C979.877 1221.47 978.613 1220.21 978.613 1218.65C978.613 1217.09 979.877 1215.82 981.435 1215.82C982.994 1215.82 984.258 1217.09 984.258 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1218.65C1001.19 1220.21 999.93 1221.47 998.371 1221.47C996.812 1221.47 995.548 1220.21 995.548 1218.65C995.548 1217.09 996.812 1215.82 998.371 1215.82C999.93 1215.82 1001.19 1217.09 1001.19 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1218.65C1018.13 1220.21 1016.87 1221.47 1015.31 1221.47C1013.75 1221.47 1012.48 1220.21 1012.48 1218.65C1012.48 1217.09 1013.75 1215.82 1015.31 1215.82C1016.87 1215.82 1018.13 1217.09 1018.13 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1218.65C1035.06 1220.21 1033.8 1221.47 1032.24 1221.47C1030.68 1221.47 1029.42 1220.21 1029.42 1218.65C1029.42 1217.09 1030.68 1215.82 1032.24 1215.82C1033.8 1215.82 1035.06 1217.09 1035.06 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M1052 1218.65C1052 1220.21 1050.74 1221.47 1049.18 1221.47C1047.62 1221.47 1046.35 1220.21 1046.35 1218.65C1046.35 1217.09 1047.62 1215.82 1049.18 1215.82C1050.74 1215.82 1052 1217.09 1052 1218.65Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1235.59C882.645 1237.15 881.381 1238.41 879.823 1238.41C878.264 1238.41 877 1237.15 877 1235.59C877 1234.03 878.264 1232.76 879.823 1232.76C881.381 1232.76 882.645 1234.03 882.645 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1235.59C899.581 1237.15 898.317 1238.41 896.758 1238.41C895.199 1238.41 893.935 1237.15 893.935 1235.59C893.935 1234.03 895.199 1232.76 896.758 1232.76C898.317 1232.76 899.581 1234.03 899.581 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1235.59C916.516 1237.15 915.252 1238.41 913.694 1238.41C912.135 1238.41 910.871 1237.15 910.871 1235.59C910.871 1234.03 912.135 1232.76 913.694 1232.76C915.252 1232.76 916.516 1234.03 916.516 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1235.59C933.452 1237.15 932.188 1238.41 930.629 1238.41C929.07 1238.41 927.806 1237.15 927.806 1235.59C927.806 1234.03 929.07 1232.76 930.629 1232.76C932.188 1232.76 933.452 1234.03 933.452 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1235.59C950.387 1237.15 949.123 1238.41 947.565 1238.41C946.006 1238.41 944.742 1237.15 944.742 1235.59C944.742 1234.03 946.006 1232.76 947.565 1232.76C949.123 1232.76 950.387 1234.03 950.387 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1235.59C967.323 1237.15 966.059 1238.41 964.5 1238.41C962.941 1238.41 961.677 1237.15 961.677 1235.59C961.677 1234.03 962.941 1232.76 964.5 1232.76C966.059 1232.76 967.323 1234.03 967.323 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1235.59C984.258 1237.15 982.994 1238.41 981.435 1238.41C979.877 1238.41 978.613 1237.15 978.613 1235.59C978.613 1234.03 979.877 1232.76 981.435 1232.76C982.994 1232.76 984.258 1234.03 984.258 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1235.59C1001.19 1237.15 999.93 1238.41 998.371 1238.41C996.812 1238.41 995.548 1237.15 995.548 1235.59C995.548 1234.03 996.812 1232.76 998.371 1232.76C999.93 1232.76 1001.19 1234.03 1001.19 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1235.59C1018.13 1237.15 1016.87 1238.41 1015.31 1238.41C1013.75 1238.41 1012.48 1237.15 1012.48 1235.59C1012.48 1234.03 1013.75 1232.76 1015.31 1232.76C1016.87 1232.76 1018.13 1234.03 1018.13 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1235.59C1035.06 1237.15 1033.8 1238.41 1032.24 1238.41C1030.68 1238.41 1029.42 1237.15 1029.42 1235.59C1029.42 1234.03 1030.68 1232.76 1032.24 1232.76C1033.8 1232.76 1035.06 1234.03 1035.06 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M1052 1235.59C1052 1237.15 1050.74 1238.41 1049.18 1238.41C1047.62 1238.41 1046.35 1237.15 1046.35 1235.59C1046.35 1234.03 1047.62 1232.76 1049.18 1232.76C1050.74 1232.76 1052 1234.03 1052 1235.59Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1252.53C882.645 1254.09 881.381 1255.35 879.823 1255.35C878.264 1255.35 877 1254.09 877 1252.53C877 1250.97 878.264 1249.71 879.823 1249.71C881.381 1249.71 882.645 1250.97 882.645 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1252.53C899.581 1254.09 898.317 1255.35 896.758 1255.35C895.199 1255.35 893.935 1254.09 893.935 1252.53C893.935 1250.97 895.199 1249.71 896.758 1249.71C898.317 1249.71 899.581 1250.97 899.581 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1252.53C916.516 1254.09 915.252 1255.35 913.694 1255.35C912.135 1255.35 910.871 1254.09 910.871 1252.53C910.871 1250.97 912.135 1249.71 913.694 1249.71C915.252 1249.71 916.516 1250.97 916.516 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1252.53C933.452 1254.09 932.188 1255.35 930.629 1255.35C929.07 1255.35 927.806 1254.09 927.806 1252.53C927.806 1250.97 929.07 1249.71 930.629 1249.71C932.188 1249.71 933.452 1250.97 933.452 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1252.53C950.387 1254.09 949.123 1255.35 947.565 1255.35C946.006 1255.35 944.742 1254.09 944.742 1252.53C944.742 1250.97 946.006 1249.71 947.565 1249.71C949.123 1249.71 950.387 1250.97 950.387 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1252.53C967.323 1254.09 966.059 1255.35 964.5 1255.35C962.941 1255.35 961.677 1254.09 961.677 1252.53C961.677 1250.97 962.941 1249.71 964.5 1249.71C966.059 1249.71 967.323 1250.97 967.323 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1252.53C984.258 1254.09 982.994 1255.35 981.435 1255.35C979.877 1255.35 978.613 1254.09 978.613 1252.53C978.613 1250.97 979.877 1249.71 981.435 1249.71C982.994 1249.71 984.258 1250.97 984.258 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1252.53C1001.19 1254.09 999.93 1255.35 998.371 1255.35C996.812 1255.35 995.548 1254.09 995.548 1252.53C995.548 1250.97 996.812 1249.71 998.371 1249.71C999.93 1249.71 1001.19 1250.97 1001.19 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1252.53C1018.13 1254.09 1016.87 1255.35 1015.31 1255.35C1013.75 1255.35 1012.48 1254.09 1012.48 1252.53C1012.48 1250.97 1013.75 1249.71 1015.31 1249.71C1016.87 1249.71 1018.13 1250.97 1018.13 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1252.53C1035.06 1254.09 1033.8 1255.35 1032.24 1255.35C1030.68 1255.35 1029.42 1254.09 1029.42 1252.53C1029.42 1250.97 1030.68 1249.71 1032.24 1249.71C1033.8 1249.71 1035.06 1250.97 1035.06 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M1052 1252.53C1052 1254.09 1050.74 1255.35 1049.18 1255.35C1047.62 1255.35 1046.35 1254.09 1046.35 1252.53C1046.35 1250.97 1047.62 1249.71 1049.18 1249.71C1050.74 1249.71 1052 1250.97 1052 1252.53Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1269.47C882.645 1271.03 881.381 1272.29 879.823 1272.29C878.264 1272.29 877 1271.03 877 1269.47C877 1267.91 878.264 1266.65 879.823 1266.65C881.381 1266.65 882.645 1267.91 882.645 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1269.47C899.581 1271.03 898.317 1272.29 896.758 1272.29C895.199 1272.29 893.935 1271.03 893.935 1269.47C893.935 1267.91 895.199 1266.65 896.758 1266.65C898.317 1266.65 899.581 1267.91 899.581 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1269.47C916.516 1271.03 915.252 1272.29 913.694 1272.29C912.135 1272.29 910.871 1271.03 910.871 1269.47C910.871 1267.91 912.135 1266.65 913.694 1266.65C915.252 1266.65 916.516 1267.91 916.516 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1269.47C933.452 1271.03 932.188 1272.29 930.629 1272.29C929.07 1272.29 927.806 1271.03 927.806 1269.47C927.806 1267.91 929.07 1266.65 930.629 1266.65C932.188 1266.65 933.452 1267.91 933.452 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1269.47C950.387 1271.03 949.123 1272.29 947.565 1272.29C946.006 1272.29 944.742 1271.03 944.742 1269.47C944.742 1267.91 946.006 1266.65 947.565 1266.65C949.123 1266.65 950.387 1267.91 950.387 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1269.47C967.323 1271.03 966.059 1272.29 964.5 1272.29C962.941 1272.29 961.677 1271.03 961.677 1269.47C961.677 1267.91 962.941 1266.65 964.5 1266.65C966.059 1266.65 967.323 1267.91 967.323 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1269.47C984.258 1271.03 982.994 1272.29 981.435 1272.29C979.877 1272.29 978.613 1271.03 978.613 1269.47C978.613 1267.91 979.877 1266.65 981.435 1266.65C982.994 1266.65 984.258 1267.91 984.258 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1269.47C1001.19 1271.03 999.93 1272.29 998.371 1272.29C996.812 1272.29 995.548 1271.03 995.548 1269.47C995.548 1267.91 996.812 1266.65 998.371 1266.65C999.93 1266.65 1001.19 1267.91 1001.19 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1269.47C1018.13 1271.03 1016.87 1272.29 1015.31 1272.29C1013.75 1272.29 1012.48 1271.03 1012.48 1269.47C1012.48 1267.91 1013.75 1266.65 1015.31 1266.65C1016.87 1266.65 1018.13 1267.91 1018.13 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1269.47C1035.06 1271.03 1033.8 1272.29 1032.24 1272.29C1030.68 1272.29 1029.42 1271.03 1029.42 1269.47C1029.42 1267.91 1030.68 1266.65 1032.24 1266.65C1033.8 1266.65 1035.06 1267.91 1035.06 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M1052 1269.47C1052 1271.03 1050.74 1272.29 1049.18 1272.29C1047.62 1272.29 1046.35 1271.03 1046.35 1269.47C1046.35 1267.91 1047.62 1266.65 1049.18 1266.65C1050.74 1266.65 1052 1267.91 1052 1269.47Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1286.41C882.645 1287.97 881.381 1289.24 879.823 1289.24C878.264 1289.24 877 1287.97 877 1286.41C877 1284.85 878.264 1283.59 879.823 1283.59C881.381 1283.59 882.645 1284.85 882.645 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1286.41C899.581 1287.97 898.317 1289.24 896.758 1289.24C895.199 1289.24 893.935 1287.97 893.935 1286.41C893.935 1284.85 895.199 1283.59 896.758 1283.59C898.317 1283.59 899.581 1284.85 899.581 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1286.41C916.516 1287.97 915.252 1289.24 913.694 1289.24C912.135 1289.24 910.871 1287.97 910.871 1286.41C910.871 1284.85 912.135 1283.59 913.694 1283.59C915.252 1283.59 916.516 1284.85 916.516 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1286.41C933.452 1287.97 932.188 1289.24 930.629 1289.24C929.07 1289.24 927.806 1287.97 927.806 1286.41C927.806 1284.85 929.07 1283.59 930.629 1283.59C932.188 1283.59 933.452 1284.85 933.452 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1286.41C950.387 1287.97 949.123 1289.24 947.565 1289.24C946.006 1289.24 944.742 1287.97 944.742 1286.41C944.742 1284.85 946.006 1283.59 947.565 1283.59C949.123 1283.59 950.387 1284.85 950.387 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1286.41C967.323 1287.97 966.059 1289.24 964.5 1289.24C962.941 1289.24 961.677 1287.97 961.677 1286.41C961.677 1284.85 962.941 1283.59 964.5 1283.59C966.059 1283.59 967.323 1284.85 967.323 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1286.41C984.258 1287.97 982.994 1289.24 981.435 1289.24C979.877 1289.24 978.613 1287.97 978.613 1286.41C978.613 1284.85 979.877 1283.59 981.435 1283.59C982.994 1283.59 984.258 1284.85 984.258 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1286.41C1001.19 1287.97 999.93 1289.24 998.371 1289.24C996.812 1289.24 995.548 1287.97 995.548 1286.41C995.548 1284.85 996.812 1283.59 998.371 1283.59C999.93 1283.59 1001.19 1284.85 1001.19 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1286.41C1018.13 1287.97 1016.87 1289.24 1015.31 1289.24C1013.75 1289.24 1012.48 1287.97 1012.48 1286.41C1012.48 1284.85 1013.75 1283.59 1015.31 1283.59C1016.87 1283.59 1018.13 1284.85 1018.13 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1286.41C1035.06 1287.97 1033.8 1289.24 1032.24 1289.24C1030.68 1289.24 1029.42 1287.97 1029.42 1286.41C1029.42 1284.85 1030.68 1283.59 1032.24 1283.59C1033.8 1283.59 1035.06 1284.85 1035.06 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M1052 1286.41C1052 1287.97 1050.74 1289.24 1049.18 1289.24C1047.62 1289.24 1046.35 1287.97 1046.35 1286.41C1046.35 1284.85 1047.62 1283.59 1049.18 1283.59C1050.74 1283.59 1052 1284.85 1052 1286.41Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1303.35C882.645 1304.91 881.381 1306.18 879.823 1306.18C878.264 1306.18 877 1304.91 877 1303.35C877 1301.79 878.264 1300.53 879.823 1300.53C881.381 1300.53 882.645 1301.79 882.645 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1303.35C899.581 1304.91 898.317 1306.18 896.758 1306.18C895.199 1306.18 893.935 1304.91 893.935 1303.35C893.935 1301.79 895.199 1300.53 896.758 1300.53C898.317 1300.53 899.581 1301.79 899.581 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1303.35C916.516 1304.91 915.252 1306.18 913.694 1306.18C912.135 1306.18 910.871 1304.91 910.871 1303.35C910.871 1301.79 912.135 1300.53 913.694 1300.53C915.252 1300.53 916.516 1301.79 916.516 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1303.35C933.452 1304.91 932.188 1306.18 930.629 1306.18C929.07 1306.18 927.806 1304.91 927.806 1303.35C927.806 1301.79 929.07 1300.53 930.629 1300.53C932.188 1300.53 933.452 1301.79 933.452 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1303.35C950.387 1304.91 949.123 1306.18 947.565 1306.18C946.006 1306.18 944.742 1304.91 944.742 1303.35C944.742 1301.79 946.006 1300.53 947.565 1300.53C949.123 1300.53 950.387 1301.79 950.387 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1303.35C967.323 1304.91 966.059 1306.18 964.5 1306.18C962.941 1306.18 961.677 1304.91 961.677 1303.35C961.677 1301.79 962.941 1300.53 964.5 1300.53C966.059 1300.53 967.323 1301.79 967.323 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1303.35C984.258 1304.91 982.994 1306.18 981.435 1306.18C979.877 1306.18 978.613 1304.91 978.613 1303.35C978.613 1301.79 979.877 1300.53 981.435 1300.53C982.994 1300.53 984.258 1301.79 984.258 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1303.35C1001.19 1304.91 999.93 1306.18 998.371 1306.18C996.812 1306.18 995.548 1304.91 995.548 1303.35C995.548 1301.79 996.812 1300.53 998.371 1300.53C999.93 1300.53 1001.19 1301.79 1001.19 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1303.35C1018.13 1304.91 1016.87 1306.18 1015.31 1306.18C1013.75 1306.18 1012.48 1304.91 1012.48 1303.35C1012.48 1301.79 1013.75 1300.53 1015.31 1300.53C1016.87 1300.53 1018.13 1301.79 1018.13 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1303.35C1035.06 1304.91 1033.8 1306.18 1032.24 1306.18C1030.68 1306.18 1029.42 1304.91 1029.42 1303.35C1029.42 1301.79 1030.68 1300.53 1032.24 1300.53C1033.8 1300.53 1035.06 1301.79 1035.06 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M1052 1303.35C1052 1304.91 1050.74 1306.18 1049.18 1306.18C1047.62 1306.18 1046.35 1304.91 1046.35 1303.35C1046.35 1301.79 1047.62 1300.53 1049.18 1300.53C1050.74 1300.53 1052 1301.79 1052 1303.35Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1320.29C882.645 1321.85 881.381 1323.12 879.823 1323.12C878.264 1323.12 877 1321.85 877 1320.29C877 1318.73 878.264 1317.47 879.823 1317.47C881.381 1317.47 882.645 1318.73 882.645 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1320.29C899.581 1321.85 898.317 1323.12 896.758 1323.12C895.199 1323.12 893.935 1321.85 893.935 1320.29C893.935 1318.73 895.199 1317.47 896.758 1317.47C898.317 1317.47 899.581 1318.73 899.581 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1320.29C916.516 1321.85 915.252 1323.12 913.694 1323.12C912.135 1323.12 910.871 1321.85 910.871 1320.29C910.871 1318.73 912.135 1317.47 913.694 1317.47C915.252 1317.47 916.516 1318.73 916.516 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1320.29C933.452 1321.85 932.188 1323.12 930.629 1323.12C929.07 1323.12 927.806 1321.85 927.806 1320.29C927.806 1318.73 929.07 1317.47 930.629 1317.47C932.188 1317.47 933.452 1318.73 933.452 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1320.29C950.387 1321.85 949.123 1323.12 947.565 1323.12C946.006 1323.12 944.742 1321.85 944.742 1320.29C944.742 1318.73 946.006 1317.47 947.565 1317.47C949.123 1317.47 950.387 1318.73 950.387 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1320.29C967.323 1321.85 966.059 1323.12 964.5 1323.12C962.941 1323.12 961.677 1321.85 961.677 1320.29C961.677 1318.73 962.941 1317.47 964.5 1317.47C966.059 1317.47 967.323 1318.73 967.323 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1320.29C984.258 1321.85 982.994 1323.12 981.435 1323.12C979.877 1323.12 978.613 1321.85 978.613 1320.29C978.613 1318.73 979.877 1317.47 981.435 1317.47C982.994 1317.47 984.258 1318.73 984.258 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1320.29C1001.19 1321.85 999.93 1323.12 998.371 1323.12C996.812 1323.12 995.548 1321.85 995.548 1320.29C995.548 1318.73 996.812 1317.47 998.371 1317.47C999.93 1317.47 1001.19 1318.73 1001.19 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1320.29C1018.13 1321.85 1016.87 1323.12 1015.31 1323.12C1013.75 1323.12 1012.48 1321.85 1012.48 1320.29C1012.48 1318.73 1013.75 1317.47 1015.31 1317.47C1016.87 1317.47 1018.13 1318.73 1018.13 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1320.29C1035.06 1321.85 1033.8 1323.12 1032.24 1323.12C1030.68 1323.12 1029.42 1321.85 1029.42 1320.29C1029.42 1318.73 1030.68 1317.47 1032.24 1317.47C1033.8 1317.47 1035.06 1318.73 1035.06 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M1052 1320.29C1052 1321.85 1050.74 1323.12 1049.18 1323.12C1047.62 1323.12 1046.35 1321.85 1046.35 1320.29C1046.35 1318.73 1047.62 1317.47 1049.18 1317.47C1050.74 1317.47 1052 1318.73 1052 1320.29Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1337.24C882.645 1338.79 881.381 1340.06 879.823 1340.06C878.264 1340.06 877 1338.79 877 1337.24C877 1335.68 878.264 1334.41 879.823 1334.41C881.381 1334.41 882.645 1335.68 882.645 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1337.24C899.581 1338.79 898.317 1340.06 896.758 1340.06C895.199 1340.06 893.935 1338.79 893.935 1337.24C893.935 1335.68 895.199 1334.41 896.758 1334.41C898.317 1334.41 899.581 1335.68 899.581 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1337.24C916.516 1338.79 915.252 1340.06 913.694 1340.06C912.135 1340.06 910.871 1338.79 910.871 1337.24C910.871 1335.68 912.135 1334.41 913.694 1334.41C915.252 1334.41 916.516 1335.68 916.516 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1337.24C933.452 1338.79 932.188 1340.06 930.629 1340.06C929.07 1340.06 927.806 1338.79 927.806 1337.24C927.806 1335.68 929.07 1334.41 930.629 1334.41C932.188 1334.41 933.452 1335.68 933.452 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1337.24C950.387 1338.79 949.123 1340.06 947.565 1340.06C946.006 1340.06 944.742 1338.79 944.742 1337.24C944.742 1335.68 946.006 1334.41 947.565 1334.41C949.123 1334.41 950.387 1335.68 950.387 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1337.24C967.323 1338.79 966.059 1340.06 964.5 1340.06C962.941 1340.06 961.677 1338.79 961.677 1337.24C961.677 1335.68 962.941 1334.41 964.5 1334.41C966.059 1334.41 967.323 1335.68 967.323 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1337.24C984.258 1338.79 982.994 1340.06 981.435 1340.06C979.877 1340.06 978.613 1338.79 978.613 1337.24C978.613 1335.68 979.877 1334.41 981.435 1334.41C982.994 1334.41 984.258 1335.68 984.258 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1337.24C1001.19 1338.79 999.93 1340.06 998.371 1340.06C996.812 1340.06 995.548 1338.79 995.548 1337.24C995.548 1335.68 996.812 1334.41 998.371 1334.41C999.93 1334.41 1001.19 1335.68 1001.19 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1337.24C1018.13 1338.79 1016.87 1340.06 1015.31 1340.06C1013.75 1340.06 1012.48 1338.79 1012.48 1337.24C1012.48 1335.68 1013.75 1334.41 1015.31 1334.41C1016.87 1334.41 1018.13 1335.68 1018.13 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1337.24C1035.06 1338.79 1033.8 1340.06 1032.24 1340.06C1030.68 1340.06 1029.42 1338.79 1029.42 1337.24C1029.42 1335.68 1030.68 1334.41 1032.24 1334.41C1033.8 1334.41 1035.06 1335.68 1035.06 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M1052 1337.24C1052 1338.79 1050.74 1340.06 1049.18 1340.06C1047.62 1340.06 1046.35 1338.79 1046.35 1337.24C1046.35 1335.68 1047.62 1334.41 1049.18 1334.41C1050.74 1334.41 1052 1335.68 1052 1337.24Z"
                    fill={color2}
                />
                <path
                    d="M882.645 1354.18C882.645 1355.74 881.381 1357 879.823 1357C878.264 1357 877 1355.74 877 1354.18C877 1352.62 878.264 1351.35 879.823 1351.35C881.381 1351.35 882.645 1352.62 882.645 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M899.581 1354.18C899.581 1355.74 898.317 1357 896.758 1357C895.199 1357 893.935 1355.74 893.935 1354.18C893.935 1352.62 895.199 1351.35 896.758 1351.35C898.317 1351.35 899.581 1352.62 899.581 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M916.516 1354.18C916.516 1355.74 915.252 1357 913.694 1357C912.135 1357 910.871 1355.74 910.871 1354.18C910.871 1352.62 912.135 1351.35 913.694 1351.35C915.252 1351.35 916.516 1352.62 916.516 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M933.452 1354.18C933.452 1355.74 932.188 1357 930.629 1357C929.07 1357 927.806 1355.74 927.806 1354.18C927.806 1352.62 929.07 1351.35 930.629 1351.35C932.188 1351.35 933.452 1352.62 933.452 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M950.387 1354.18C950.387 1355.74 949.123 1357 947.565 1357C946.006 1357 944.742 1355.74 944.742 1354.18C944.742 1352.62 946.006 1351.35 947.565 1351.35C949.123 1351.35 950.387 1352.62 950.387 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M967.323 1354.18C967.323 1355.74 966.059 1357 964.5 1357C962.941 1357 961.677 1355.74 961.677 1354.18C961.677 1352.62 962.941 1351.35 964.5 1351.35C966.059 1351.35 967.323 1352.62 967.323 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M984.258 1354.18C984.258 1355.74 982.994 1357 981.435 1357C979.877 1357 978.613 1355.74 978.613 1354.18C978.613 1352.62 979.877 1351.35 981.435 1351.35C982.994 1351.35 984.258 1352.62 984.258 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M1001.19 1354.18C1001.19 1355.74 999.93 1357 998.371 1357C996.812 1357 995.548 1355.74 995.548 1354.18C995.548 1352.62 996.812 1351.35 998.371 1351.35C999.93 1351.35 1001.19 1352.62 1001.19 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M1018.13 1354.18C1018.13 1355.74 1016.87 1357 1015.31 1357C1013.75 1357 1012.48 1355.74 1012.48 1354.18C1012.48 1352.62 1013.75 1351.35 1015.31 1351.35C1016.87 1351.35 1018.13 1352.62 1018.13 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M1035.06 1354.18C1035.06 1355.74 1033.8 1357 1032.24 1357C1030.68 1357 1029.42 1355.74 1029.42 1354.18C1029.42 1352.62 1030.68 1351.35 1032.24 1351.35C1033.8 1351.35 1035.06 1352.62 1035.06 1354.18Z"
                    fill={color2}
                />
                <path
                    d="M1052 1354.18C1052 1355.74 1050.74 1357 1049.18 1357C1047.62 1357 1046.35 1355.74 1046.35 1354.18C1046.35 1352.62 1047.62 1351.35 1049.18 1351.35C1050.74 1351.35 1052 1352.62 1052 1354.18Z"
                    fill={color2}
                />
            </svg>
        </div>
    );
};
